import { defineComponent as _defineComponent } from 'vue'
import 'maplibre-gl/dist/maplibre-gl.css';

import { onBeforeUnmount, onMounted, ref } from 'vue';

import MapTilerInner from '@/components/MapTilerInner.vue';
import { ShopWall } from '~model';
import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapTilerMap',
  props: {
  shopWall: {
    type: Array as () => ShopWall,
    required: true,
  },
  init: {
    type: Boolean,
    required: true,
  },
  searchResultsRef: {
    type: HTMLElement,
    required: true,
  },
},
  setup(__props) {

const props = __props

const initalized = ref(false);

const map = ref<Element | null>(null);



function getHeight(): number {
  return map.value?.clientHeight || 0;
}

const searchResultDiv = props.searchResultsRef as HTMLElement;
const resultsDiv = ref(searchResultDiv.querySelector('.search-container'));

function handleResize(): void {
  const mapHeight = getHeight();
  resultsDiv.value.style.maxHeight = `${mapHeight - 90}px`;
}

window.addEventListener('resize', handleResize);

onMounted(async () => {
  resultsDiv.value.style.overflowY = 'scroll';
  resultsDiv.value.style.overflowX = 'hidden';

  setTimeout(() => {
    handleResize();
  }, 300);

  if (props.init) {
    initalized.value = false;
    await store.dispatch('initMaptiler');
    initalized.value = true;
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

return { __sfc: true,initalized, map, props, getHeight, searchResultDiv, resultsDiv, handleResize, MapTilerInner, store }
}

})